/**
 * 新首页数据源开关（由环境变量控制）
 *
 * VITE_NEW_INDEX_USE_MOCK=true  - 使用 mock（城市新闻热榜 / 山海名城 / VR / slogan 轮播）
 * VITE_NEW_INDEX_USE_MOCK=false - 使用 API
 *
 * 在 .env.dev / .env.pro / .env.test 中配置
 */
export const USE_NEW_INDEX_MOCK = import.meta.env.VITE_NEW_INDEX_USE_MOCK === 'true';

/** 问青岛服务平台模块（newIndex） */
export const SHOW_ASK_QINGDAO_SECTION = false;
